// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__FBZq1","footer":"ModalCreateQualiphyProcedure_footer__3_-TG","additionData":"ModalCreateQualiphyProcedure_additionData__3NPK3"};